import React from 'react'
import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";

// ThinkWare section components
import EtThinkWareHero from "@/components/sections/thinkware/EtThinkWareHero";
import EtThinkWareLibrary from "@/components/sections/thinkware/EtThinkWareLibrary";
import EtThinkWareStats from "@/components/sections/thinkware/EtThinkWareStats";
import EtThinkWareCTA from "@/components/sections/thinkware/EtThinkWareCTA";

const EtThinkWare = () => {

  // First Created – 21 Nov 2025
  // Author – Atul Pandey
  // Purpose – Container page for ThinkWare content (video podcasts, thought pieces)

  return (
    <div className="font-poppins">
      {/* Header */}
      <EtHeader />

      {/* Hero */}
      <EtThinkWareHero />

      {/* Library Section */}
      <EtThinkWareLibrary />

      {/* Stats / Trends Section */}
      {/* <EtThinkWareStats /> */}

      {/* CTA Section */}
      <EtThinkWareCTA />

      {/* Footer */}
      <EtFooter />
    </div>
  )
}

export default EtThinkWare